import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setQuiz } from "../../../store/actions";
import ReactHtmlParser from "react-html-parser";
import HtmlParser from "react-html-parser";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { CKEditor } from 'ckeditor4-react';
import draftToHtml from "draftjs-to-html";
import {
  EditorState,
  convertToRaw,
  RichUtils,
  CompositeDecorator,
  ContentState,
  convertFromHTML,
  convertFromRaw,
} from "draft-js";
import { MathJax, MathJaxContext } from "better-react-mathjax";
import Dropzone from 'react-dropzone-uploader';
import 'react-dropzone-uploader/dist/styles.css';
import {  RemovedDocumentToAws, UploadDocumentToAws } from "../../../services/QuizService";
import { BASE_URL, UPLOAD_ROOT_PATH } from "../../../utils/Constants";
import { FetchFileIcon, GetFileSize, getRandomOrder } from "../../../utils/commonFunction";
import { RenderAttachList } from "../../common/RenderAttachListFeed";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { handleUploadToS3BucketUrl2 } from "../../common/uploadFileToS3";
import moment from "moment";
import Swal from "sweetalert2";
import { CustomFileUploadPreview } from "../../../utils/CommonGroupingItem";

const removeHTMLTagsRegex = /(<([^>]+)>|&nbsp;)/gi;

function OptionList({
  grpId, 
  qInd,
  item,
  index,
  question,
  refreshprops,
  answer,
  setanswer,
  isAssessmentReview,
}) {
  var data = "";
  try {
    data = answer;
  } catch (error) {
    data = "";
  }
  const dispatch = useDispatch();
  const onChange = (e) => {
    var arr = e.target.value;
    setanswer(arr);
    if(grpId){
      dispatch(setQuiz([`qa${grpId}qa`, qInd, { ...question, selected: arr }]));
    } else {
      dispatch(setQuiz([`qa${item.qid}qa`, { ...question, selected: arr }]));
    }
    refreshprops();
  };
  return (
    <div className={`custom-control custom-radio ${isAssessmentReview ? 'pointer-none':''}`}>
      <input
        type="radio"
        className="custom-control-input"
        name="example"
        onChange={(event) => onChange(event)}
        checked={data == item.oid}
        id={`customRadio_${index}`}
        value={item.oid}
      />
      <label className="custom-control-label" htmlFor={`customRadio_${index}`}>
        <span className={"quiz__single__ans__active__dot " + (data == item.oid ? 'active' : '')}></span>
        <li
          className={(data == item.oid) ? 'active-choice' : ''}
          id={`customRadio_${index}`}
          value={item.oid}
        >
          {HtmlParser(`${item.q_option}`)}
        </li>
      </label>
    </div>
  );
}

function OptionListCheckbox({
  grpId, 
  qInd,
  item,
  index,
  question,
  refreshprops,
  answer,
  setanswer,
  isAssessmentReview,
}) {
  var data = "";
  try {
    if (Array.isArray(answer)) {
      data = answer.indexOf(item.oid + "");
    } else {
      data = "";
    }
  } catch (error) {
    data = "";
  }
  const dispatch = useDispatch();
  const onChange = (e) => {
    var checked = 0;
    if (e.target.checked) {
      var arr = answer.map((item) => item);
      arr.push(e.target.value);
      setanswer(arr);

      arr.map((data) => {
        if (data != "" && data != null) {
          checked++;
        }
      });
     
      if(grpId){
        dispatch(
          setQuiz([
            `qa${grpId}qa`, qInd,
            {
              ...question,
              selected: arr,
            },
          ])
        );
      } else {
        dispatch(
          setQuiz([
            `qa${item.qid}qa`,
            {
              ...question,
              selected: arr,
            },
          ])
        );
      }
      
    } else {
      var arr = answer.map((item) => item);
      const index = arr.indexOf(e.target.value + "");
      if (index > -1) {
        arr.splice(index, 1);
      }
      setanswer(arr);
      arr.map((data) => {
        if (data != "" && data != null) {
          checked++;
        }
      });
      if(grpId){
        dispatch(
          setQuiz([
            `qa${grpId}qa`, qInd,
            {
              ...question,
              selected: arr,
            },
          ])
        );
      } else {
        dispatch(
          setQuiz([
            `qa${item.qid}qa`,
            {
              ...question,
              selected: arr,
            },
          ])
        );
      }
    }
    refreshprops();
  };
  return (
    <div className={`custom-control custom-checkbox ${isAssessmentReview ? 'pointer-none':''}`}>
      <input
        className="custom-control-input"
        name="example"
        type="checkbox"
        value={item.oid}
        id={`customCheck_${index}`}
        checked={
          (data != undefined && data != "" && data != null && data != -1) ||
            data == 0
            ? true
            : false
        }
        onChange={(event) => onChange(event)}
      />

      <label className="custom-control-label m-choice-option col-md-12" for={`customCheck_${index}`}>
        {HtmlParser(item.q_option)}        
      </label>
    </div>
  );
}

function OptionShortAnswer({
  grpId, 
  qInd,
  item,
  index,
  question,
  refreshprops,
  answer,
  setanswer,
  isAssessmentReview,
}) {

  var data = "";
  try {
    data = answer;
  } catch (error) {
    data = "";
  }
  const dispatch = useDispatch();
  const onChange = (e) => {
    var arr = e.target.value;
    setanswer(arr);
    if(grpId){
      dispatch(setQuiz([`qa${grpId}qa`, qInd, { ...question, selected: arr }]));
    } else {
      dispatch(setQuiz([`qa${question.qid}qa`, { ...question, selected: arr }]));
    }
    refreshprops();
  };

  return (
    <div className={`form-group ${isAssessmentReview ? 'pointer-none':''}`}>
      <textarea
        type="text"
        value={data}
        onChange={onChange}
        className="form-control"
        placeholder="Short Answer"
      ></textarea>
    </div>
  );
}

function OptionLongAnswer({ grpId, qInd, question, refreshprops, answer, setanswer,isAssessmentReview}) {
  var data = "";
  try {
    data = answer;
  } catch (error) {
    data = "";
  }
  const dispatch = useDispatch();
   // Create a ref to store the timeout ID
   const timeoutRef = useRef(null);
  
   const onChange = (e) => {
     var arr = e.target.value;
     setanswer(arr);
     
     // Clear previous timeout if it exists
     if (timeoutRef.current) {
       clearTimeout(timeoutRef.current);
     }
     
     // Set new timeout
     timeoutRef.current = setTimeout(() => {
       if(grpId){
         dispatch(setQuiz([`qa${grpId}qa`, qInd, { ...question, selected: arr }]));
       } else {
         dispatch(setQuiz([`qa${question.qid}qa`, { ...question, selected: arr }]));
       }
     }, 500); // 500ms delay
   };
 
   // Clean up the timeout when the component unmounts
   useEffect(() => {
     return () => {
       if (timeoutRef.current) {
         clearTimeout(timeoutRef.current);
       }
     };
   }, []);

  return (
    <div className={`form-group ${isAssessmentReview ? 'pointer-none':''}`}>
      <textarea
        type="text"
        value={HtmlParser(data)}
        onChange={onChange}
        className="form-control"
        placeholder="Long Answer"
      ></textarea>
    </div>
  );
}

function FillInTheBlanks({
  grpId,
  qInd,
  question,
  refreshprops,
  answer,
  setanswer,
  isAssessmentReview,
}) {
  const dispatch = useDispatch();
  const inputString = question.question.replace(removeHTMLTagsRegex, "").replaceAll("&#39;","'");

  const numInputs = inputString.split('___').length - 1;

  const [inputValues, setInputValues] = useState(Array(numInputs).fill(''));
  const [answers, setAnswers] = useState([]);
  useEffect(()=>{
    setInputValues(Array(numInputs).fill(''));
    if(Array.isArray(answer) && answer.length > 0){
      setAnswers(answer?.map(a=>typeof a?.q_option_match === "string" ? a?.q_option_match : ""));
    }
  },[answer]);

  function handleChange(event, index) {
    const newValues = [...inputValues];
    newValues[index] = event.target.value;
    setInputValues(newValues);

    const newAnswers = [...answers];
    newAnswers[index] = event.target.value;
    const selected = newAnswers?.map((item, ind) => {
      return { ...question.options[ind], q_option_match: item};
    });
    setanswer(selected);
      if(grpId){
        dispatch(setQuiz([`qa${grpId}qa`,  { ...question, selected: selected}]));
      }
       else {
        dispatch(setQuiz([`qa${question.qid}qa`, { ...question, selected: selected}]));
      }
      refreshprops();
  }
  const parts = inputString.split('___');

  const inputBoxes = parts.flatMap((part, index) => {
    const inputIndex = index % inputValues.length;
    if (index === parts.length - 1) {
      return <span key={index}>{part}</span>;
    } else {
      return [
      <span key={`part-${index}`}>{part}</span>,
      <input id={`input-${index}`} key={`input-${index}`} className={"form-control"} type="text" onChange={(event) => handleChange(event, inputIndex)} value={answer?.length ? answer[inputIndex]?.q_option_match : inputValues[inputIndex]} />
      ];
    }
  });


  return (
    <div className={`text-input-list ${isAssessmentReview ? 'pointer-none':''}`}>
      {inputBoxes}
      <br />
    </div>
  );
}

// Choice Matrix
function ChoiceMatrix({
  grpId,
  qInd,
  question,
  refreshprops,
  answer,
  setanswer,
  isAssessmentReview,
}) {
  const dispatch = useDispatch();
  const columns = question.options.length ? JSON.parse(question.options[0].q_option).map(item=>item.titleValue) : [];
  const rows = question.options.length ? question.options.map(item => ({ ...item, q_option: JSON.parse(item.q_option) })) : [];
  const colWidth = { width: `${100 / (columns.length + 1)}%` };

  const [inputValues, setInputValues] = useState(rows.map(item => item.q_option.map(() => (0))));

  // Reset input values whenever question changes
  useEffect(() => {
  setInputValues(
    rows.map(({ q_option }) => q_option.map(() => 0))
  );
}, [question.qid]);

  const handleChange = (rInd, colInd, optId) => {
    let newValues = [...inputValues];
    newValues[rInd] = newValues[rInd].map((item, ind) => (ind === colInd ? 1 : 0));
    setInputValues(newValues);

    // matching user answer
    const matched = rows.map((row, ind) => {
      if (optId === row.oid) {
        let matchingOrder = false;
        for (let i = 0; i < row.q_option.length; i++) {
          const isSelected = row.q_option[colInd].isSelected === true ? 1 : 0;
          if (isSelected === newValues[rInd][colInd]) {
            matchingOrder = true;
            break;
          } else {
            matchingOrder = false;
          }
        }
        return { ...row, q_option_match: row.q_option[colInd], score: matchingOrder ? row.score : 0 };
      } else {
        if (answer?.length) {
          return { ...row, q_option_match: answer[ind].q_option_match, score: answer[ind].score };
        } else {
          return { ...row, q_option_match: "", score: 0 };
        }
      }
    });
    
    setanswer(matched);

    let score = 0;
    matched.map(item=>{score+=item.score;return null;});
    if(grpId){
      dispatch(setQuiz([`qa${grpId}qa`, qInd, { ...question, selected: matched, score: score}]));
    } else {
      dispatch(setQuiz([`qa${question.qid}qa`, { ...question, selected: matched, score: score}]));
    }
    refreshprops();
  }

  return (
    <table
      className={`choice__matrix__wrapper ${isAssessmentReview ? "pointer-none" : ""}`}
    >
      <thead>
        <tr>
          <th style={colWidth}></th>
          {columns.map((col, colInd) => (
            <th key={colInd} style={colWidth}>
              {col}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {rows.map((row, rInd) => (
          <tr key={rInd}>
            <td style={colWidth}>{row?.titleValue}</td>
            {columns.map((col, colInd) => {
              const matchedAnswer = Array.isArray(answer)
                ? answer.find((item) => item?.oid === row?.oid)
                : null;

              const isChecked = matchedAnswer
                ? matchedAnswer?.q_option?.[colInd]?.titleValue ===
                matchedAnswer?.q_option_match?.titleValue
                : inputValues?.[rInd]?.[colInd] === 1;

              return (
                <td key={colInd} style={colWidth}>
                  <input
                    type="radio"
                    name={row?.oid}
                    checked={isChecked}
                    onChange={() => handleChange(rInd, colInd, row.oid)}
                  />
                </td>
              );
            })}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
// Document Upload
function DocumentUpload({
  grpId,
  qInd,
  question,
  refreshprops,
  answer,
  setanswer,
  isAssessmentReview,  
  isPreview,
  assignmentData,
  triggerClick,
}) {
  const debounceRef = useRef(null);
  const [uploadProgress , setUploadProgress] = useState([]);

  const dispatch = useDispatch();
  const {aid}= useParams()
  const [filess, setFiless] = useState([]);
  const [uploadingFiles, setUploadedFiles] = useState(false);
  const [fileCounter, setFileCounter] = useState(0);

  const [updatedQuestion, setUpdatedQuestion] = useState({...question});
  const updatedQuestionRef = useRef(updatedQuestion);

  useEffect(() => {
    setUpdatedQuestion({...question});
  }, [question]);
  
  useEffect(() => {
    updatedQuestionRef.current = updatedQuestion;
  }, [updatedQuestion]);
  
  useEffect(() => {
    const updatedFiles = (Array.isArray(answer) && answer.length > 0)
      ? answer.map(file => {
        if (!file.filePath) return file;

        const shouldAddKey = file.filePath.startsWith("Students/") && !("fileUploadedFrom" in file);
        return shouldAddKey ? { ...file, fileUploadedFrom: 1 } : file;
      })
      : [];

    setFiless(updatedFiles);

    let lastFile = Array.isArray(answer) && answer.length > 0 ? answer[answer.length - 1] : null;
    let fileCounter = lastFile?.filePath ? parseInt(lastFile.filePath.split('_')[2]) : 0;
    setFileCounter(fileCounter);
  }, [answer]);
  
 
  const handleSubmit = async(allFiles, processingQuestion,filess) => { 
    setUploadedFiles(true)
    if(isPreview) return; // if reviewScreen no need to call uploadDoc. api
    refreshprops();
    const formData = new FormData();
    const user = localStorage.getItem("user");
    const userData = JSON.parse(user);
    let awsFileUploadedUrl = [];

    setUploadProgress(prev => {
      const updatedProgress = { ...prev };
      allFiles.forEach(fileWithMeta => {
        const customId = fileWithMeta.meta.customId;
        if (!updatedProgress.hasOwnProperty(customId)) {
          updatedProgress[customId] = 0;
        }
      });
      return updatedProgress;
    });

    allFiles.forEach(fileWithMeta => {
      const file = fileWithMeta.file;
      const meta = fileWithMeta.meta;
      const randomString = Math.random().toString(36).slice(2, 7);
      const filePath =`Students/${userData?.id}_${userData?.student_crm_id}_${userData?.first_name}_${userData?.last_name}/${assignmentData?.id}_${assignmentData?.name}/${assignmentData?.name}_${userData?.student_crm_id}_${Date.now()}_${randomString}.${file?.name?.split(".").pop()}`;
 
      awsFileUploadedUrl.push({
        file_name: filePath,
        file_type: file.type,
      });
    })

    const result = await handleUploadToS3BucketUrl2(awsFileUploadedUrl, allFiles, (customId, percent) => {
      setUploadProgress(prev => ({
        ...prev,
        [customId]: percent
      }));
    });
    if(!result){
      Swal.fire({
        icon: "error",
        title: "File Upload Failed",
        timer: 2000,
      });
      return;
    }

    // Now process the uploaded files
    result.forEach((item, index) => {
      formData.append(`uploadedFiles[${index}][path]`, item.path);
      formData.append(`uploadedFiles[${index}][size]`, item.size);
    });

    formData.append(`assId`, aid);
    await UploadDocumentToAws(formData)
      .then(res => {
        if (processingQuestion?.qid == updatedQuestionRef.current?.qid) {
          setanswer([
            ...filess,
            ...res.data.map(file => ({
              ...file,
              fileUploadedFrom: 1
            }))
          ]);
        }   

        let updatedDocFiles = [...filess, ...res.data]

        if (grpId) {
          dispatch(setQuiz([`qa${grpId}qa`, qInd, { ...question, selected: updatedDocFiles }]));
        } else {
          dispatch(setQuiz([`qa${question.qid}qa`, { ...question, selected: updatedDocFiles }]));
        }
      })
      .catch(error => {
        console.error(error);
        setUploadedFiles(false);
      }).finally(() => {
        setUploadedFiles(false);
        allFiles.forEach(file => file.remove());
        triggerClick();
      });
  };
  
  // remove uploaded files
  const handleRemoveFile = (ind) => {
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then((result) => {
      if (!result.isConfirmed) return;

      RemovedDocumentToAws({ fileName: ind.fileName, assId: aid })
        .then(() => {
          const updatedFiles = [...filess];
          updatedFiles.splice(ind.i, 1);
          setFiless(updatedFiles);

          const updatedPayload = { ...question, selected: updatedFiles };
          const quizKey = grpId ? [`qa${grpId}qa`, qInd, updatedPayload] : [`qa${question.qid}qa`, updatedPayload];
          dispatch(setQuiz(quizKey));
          if (typeof triggerClick === "function") {
            triggerClick();
          }
        })
        .catch((err) => {
          console.log("Error removing file:", err);
          Swal.fire("Error", "Failed to remove the file. Please try again.", "error");
        });
    });
  };

  const getFileName = (url) => {
    const name = url?.split("/").reverse()[0];
    return name;
  }
 
  return <div className="profile-doc-upload-blk">
    <div className="row">
      {/* show/preview uploaded files */}
      {(filess && filess?.length > 0) ? Array.isArray(filess) && filess?.map((f, i) => {
        return (
          <div className="col-md-4 mb-4" key={i}>
            {RenderAttachList({ fileName: getFileName(f?.filePath), file: f, size: f.size, filePath: f?.filePath, handleRemoveFile: handleRemoveFile, showClose: !isAssessmentReview ? true : false, i })}
          </div>
        )
      }) : null}
    </div>
    {!isAssessmentReview ? <div className={`profile-doc-upload preview_file ${isAssessmentReview ? 'pointer-none':''}`}>      {/* file uploader */}
      <Dropzone
        key={question?.qid}
        onChangeStatus={(fileWithMeta, status, allFiles) => {
          if ((status === 'done' || status === 'ready') && fileWithMeta) {
            clearTimeout(debounceRef.current);

            debounceRef.current = setTimeout(() => {
              const readyFiles = allFiles.filter(
                (f) =>
                  (f.meta.status === 'done' || f.meta.status === 'ready') &&
                  !f.meta.customId
              );

              if (readyFiles.length) {
                readyFiles.forEach((f) => {
                  if (!f.meta.customId) {
                    f.meta.customId = `${f.meta.name}-${f.meta.size}-${Date.now()}-${Math.random()}`;
                  }
                });

                handleSubmit(readyFiles, question, filess);
              }
            }, 300);
          }

        }}
        autoUpload={true}
        classNames={{ submitButton: 'btn btn-primary', submitButtonContainer: ' btn-upload' }}
        styles={{ dropzone: { /*minHeight: 225*/ } }}
        accept=".zip,.jpg,.png,.jpeg,.pdf,.doc,.docx,.txt,.mp4,.mp3,.otf"
        PreviewComponent={(props) => <CustomFileUploadPreview {...props} uploadProgress={uploadProgress} />}
        inputContent={
          <lable>
            <i className="fas fa-file-upload"></i>
            <h4>
              To submit question, Drop your file here, or <span>browse</span>
            </h4>
            <p>Supports: PDF, DOCX and more</p>
          </lable>
        }
        canRemove={!uploadingFiles}
      />
    </div> : null}
  </div>
}

function DisplayQuestion(props) {
  const { question, quesno, setquestion, grpId, qInd, showQuesType, isAssessmentReview,isPreview = false } = props;
  var timer = null;
  
  const [answer, setanswer] = useState([]);
  const [choice, setchoice] = useState([]);
  const [singleanswer, setsingleanswer] = useState("");
  const [typeanswer, settypeanswer] = useState("");
  const [refresh, setrefresh] = useState(false);
  const [itemst, setItemst] = useState([]);
  const dispatch = useDispatch();
  const rightInnerRefs = useRef([]);
  const leftInnerRefs = useRef([]);
  const [finalHeightArr, setFinalHeightArr] = useState([]);
  const [isRender, setIsRender] = useState(false);
  const [showDocument, setShowDocument] = useState([]);
  const [docsSize, setDocsSize] = useState([]);
  const isMounted = useRef(true);

  useEffect(() => {
    isMounted.current = true;
    return () => {
      isMounted.current = false;
    };
  }, []);

  const refreshprops = () => {
    setrefresh(!refresh);
    props.setrefresh(!props.refresh);
  };

  useEffect(() => {
    if (question?.question_type === "Match the Column" || question?.question_type === "Order List") {
      let tempArr = JSON.parse(JSON.stringify(question))
      let tempOption = tempArr?.options ? tempArr.options : []
      let newOptionTemp = []
      if (question.selected.length > 0) {
        if(question?.question_type === "Order List"){
          question.selected.map(i => {
            question.options.map(j => {
              if (j.oid == i) {
                newOptionTemp.push(j)
              }
            })
          })
        }
        if(question?.question_type == "Match the Column"){
          question.selected.map((i, ind)=>{
            question.options.map((opt, index) => {
              if(ind == index){
                newOptionTemp.push({...opt})
              }
            })
          })
        }
        
      }
      if (newOptionTemp.length > 0) {
        tempArr.options = newOptionTemp
      }
      else {
        if (tempOption && question?.question_type === "Order List") {
          shuffleArray(tempOption)
        }
        if (tempOption) {
          tempArr.option = tempOption
        }
      }

      if((question?.question_type=="Order List" || question?.question_type=="Match the Column") && Array.isArray(question?.selected) && question?.selected.length==0){
        const selected = [];
        const selectedItems = [];
        const choice = [];

        tempOption.map((opt)=>{
          selected.push(opt.oid);
          selectedItems.push(opt.q_option);
        });
  
        question.options.map((item, i) =>{
          tempOption.map((opt, j)=>{
            if(i==j){
              if(question?.question_type == "Order List"){
                choice[i] = item.q_option + '___' + opt.q_option
              }else{
                choice[i] = item.q_option + '___' + opt.q_option_match
              }
            }
          })
        })

        if(grpId && !isAssessmentReview){
          dispatch(setQuiz([`qa${grpId}qa`, qInd, { ...question, selected: selected, choice: choice, selectedItems: selectedItems  }]))
        }else if(!isAssessmentReview){
          dispatch(setQuiz([`qa${question.qid}qa`,{ ...question, selected: selected, choice: choice, selectedItems: selectedItems }])
          );
        }
        
      }
      setItemst(tempArr)
      let tId = setTimeout(()=>{
        setIsRender(!isRender);
      },1000);
      return ()=>{clearTimeout(tId)}
    }
  }, [question])

  useEffect(() => {
    try {
      clearTimeout(timer);
      timer = null;
      timer = setInterval(() => {
        if (question.qid != null) {
          localStorage.setItem(
            `@qa${question.qid}qa`,
            parseInt(localStorage.getItem(`@qa${question.qid}qa`) || 0) + 1
          );
        }
      }, 1000);
    } catch (error) {
      console.error("display question timer error>>", error);
    }

    try {
      if(question.question_type=="Short Answer" && Array.isArray(question?.selected) && question?.selected.length){
        setsingleanswer(question?.selected[0]?.q_option);
      }else{
        setsingleanswer(question.selected);
      }
    } catch (error) {
      setsingleanswer("");
    }

    try {
      if(question.question_type=="Long Answer" && Array.isArray(question?.selected) && question?.selected.length){        
        settypeanswer(question?.selected[0]?.q_option);
      }else{
        settypeanswer(question.selected);
      }
    } catch (error) {
      settypeanswer("");
    }

    try {
      setchoice(question.choice);
    } catch (error) {
      setchoice(new Array());
    }

    return () => clearInterval(timer);
  }, [props.question]);

  function shuffleArray(array) {
    for (let i = array.length - 1; i > 0; i--) {
      const j = getRandomOrder(i);
      [array[i], array[j]] = [array[j], array[i]];
    }
  }

  const clearAnswer = () => {
    setsingleanswer("");
    setchoice(new Array());
    setanswer(new Array());
    settypeanswer("");
    refreshprops();
  };


  useEffect(() => {
    return () => {
      setsingleanswer("");
      settypeanswer("");
    };
  }, []);

  function onDragEnd(result, Arr) {
    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const items = reorder(
      Arr,
      result.source.index,
      result.destination.index
    );
    let temp = {...itemst}
    // console.log("before>>",temp)
    temp.options = [...items]
    setItemst({...temp})
    
    const optionRearranged = question?.options.map((opt, ind) =>({...opt, q_option_match : items[ind].q_option_match}));

    let arr = [];
    let selectedItemArr = [];
    let ch = choice.map((item) => item);
    temp.options.map(i => {
      arr.push((i.oid).toString())
      selectedItemArr.push(i?.q_option);
    })
    question.options.map((i, indexi) => {
      items.map((j, indexj) => {
        if (indexi == indexj) {
          ch[indexi] = i.q_option + '___' + j.q_option_match
        }
      })
    })
    var score = 0;
    var scoreArr = [];
    question.options.map((itm, i) => {
      items.map((j, indexj) => {
        if (i == indexj) {
          if (itm.oid == j.oid) {
            scoreArr.push(j.score)
            score += itm.score;
          }
          else {
            scoreArr.push(0)
          }
        }
      })
    });
    if(question?.question_type == "Match the Column"){
      if(grpId){
        dispatch(
          setQuiz([
            `qa${grpId}qa`, qInd,
            { ...question, options : optionRearranged, selected: arr, choice: ch, score, scoreArr, selectedItems: selectedItemArr  },
          ])
        );
      } else {
        dispatch(
          setQuiz([
            `qa${items[0].qid}qa`,
            { ...question, options : optionRearranged, selected: arr, choice: ch, score, scoreArr, selectedItems: selectedItemArr },
          ])
        );
      }
    }else{
      if(grpId){
        dispatch(
          setQuiz([
            `qa${grpId}qa`, qInd,
            { ...question, selected: arr, choice: ch, score, scoreArr, selectedItems: selectedItemArr  },
          ])
        );
      } else {
        dispatch(
          setQuiz([
            `qa${items[0].qid}qa`,
            { ...question, selected: arr, choice: ch, score, scoreArr, selectedItems: selectedItemArr },
          ])
        );
      }
    }
    refreshprops();
  }

  useEffect(()=>{    
    setanswer(question.selected);
    setchoice(question.choice);
    if(question.question_type=="Long Answer" && Array.isArray(question?.selected) && question?.selected.length){      
      settypeanswer(question?.selected[0]?.q_option);
    }else{
      settypeanswer(question.selected);
    }
    if(question.question_type=="Short Answer" && Array.isArray(question?.selected) && question?.selected.length){
      setsingleanswer(question?.selected[0]?.q_option);
    }else{
      setsingleanswer(question.selected);
    }
    if (question?.document) {
      const docArray = JSON.parse(question?.document);
      const docFiles = docArray.map(item => {
        if(item?.startsWith("https://s3.af-south-1.amazonaws.com/")){
          return { url: item, name: item.split("/").at(-1), size: "0" }
        }else{
          const fileUrl = BASE_URL + "/" + item.replaceAll(`${UPLOAD_ROOT_PATH}/`, "").replace("public/","");
          return { url: fileUrl, name: item.split("/").at(-1), size: "0" }
        }
      })
      setShowDocument(docFiles);
      docFiles.map(async item => {
        const size = await GetFileSize(item.url);
        setDocsSize(old=>[...old,size])
        return size;
      })
    }

    return ()=>{
      setShowDocument([]);
      setDocsSize([]);
    }
  },[question])

  useEffect(()=>{
    let lInnerSidearr = [];
    if(leftInnerRefs.current.length){
      leftInnerRefs.current.forEach((ref, index) => {
        if (ref.current) {
          const height = ref.current.clientHeight;
          lInnerSidearr.push(height);
        }
      });
    }

    let rInnerSidearr = [];
    if(rightInnerRefs.current.length){
      rightInnerRefs.current.forEach((ref, index) => {
        if (ref.current) {
          const height = ref.current.clientHeight;
          rInnerSidearr.push(height);
        }
      });
    }
    if(lInnerSidearr.length && rInnerSidearr.length){
      setFinalHeightArr(compareArrays(lInnerSidearr, rInnerSidearr));
    }
  },[itemst,isRender]);

  const compareArrays = (arr1, arr2) => {
    const result = [];
    for (let i = 0; i < Math.max(arr1.length, arr2.length); i++) {
      const val1 = arr1[i] || Number.NEGATIVE_INFINITY;
      const val2 = arr2[i] || Number.NEGATIVE_INFINITY;
      result.push(Math.max(val1, val2));
    }
    return result;
  }


  return (
    <div>
      {Object.keys(question).length > 0 && (
            <div className="">
              <label className="d-block mb-3">
                <MathJax inline dynamic>
                <span className='quiz-ques'>
                  <span>{question.question_type === "Fill in the blank" ? <p>Fill in the Blanks</p> : HtmlParser((question?.question))}</span>
                  {showQuesType}
                </span>
                {question?.description ? <span className='quiz-desc'>
                  {HtmlParser(
                    (question?.description)
                  )}
                </span> : null}
                  <div className="row">
                    {(showDocument && showDocument.length > 0) ? showDocument.map((f, i) => {
                        return <div className="col-md-4 mb-4" key={i}>
                          {RenderAttachList({ fileName: f?.name, file: f, size: docsSize[i], filePath: f?.url })}
                        </div>
                    }) : null}
                  </div>
                </MathJax>
              </label>
              <div className={`radio-group-custom radion-group-center`}>
                {/* Multiple Choice Single Answer */}
                <ul className="questions-quiz-option mb-0">
                  {question.question_type == "Multiple Choice Single Answer" &&
                    question.options.map((item, index) => (
                      <MathJax inline dynamic key={index}>
                      <OptionList
                        isAssessmentReview={isAssessmentReview}
                        grpId={grpId}
                        qInd={qInd}
                        item={item}
                        index={item.oid}
                        question={question}
                        refresh={refresh}
                        setrefresh={setrefresh}
                        refreshprops={refreshprops}
                        answer={singleanswer}
                        setanswer={setsingleanswer}
                      />
                      </MathJax>
                    ))}
                </ul>

                {/* Multiple Choice Multiple Answer */}
                {question.question_type == "Multiple Choice Multiple Answer" &&
                  question.options.map((item, index) => (
                    <MathJax inline dynamic key={index}>
                    <OptionListCheckbox
                      isAssessmentReview={isAssessmentReview}
                      grpId={grpId}
                      qInd={qInd}
                      item={item}
                      index={item.oid}
                      question={question}
                      refreshprops={refreshprops}
                      answer={answer}
                      setanswer={setanswer}
                    />
                    </MathJax>
                  ))}
                {/* Match the Column */}
                {question.question_type == "Match the Column" && (
                  <div className={`select-list-inline ${isAssessmentReview ? 'pointer-none':''}`}>
                    <ul className="list-unstyled">
                      <div className='col-md-6'>
                        {question?.options && question?.options?.map((item, index) => {
                          leftInnerRefs.current[index] = React.createRef();
                          return (
                          <MathJax inline dynamic key={index}>
                              {item?.q_option !== "" ? (
                                <li className="d-flex list-option p-0" style={{ height: `${finalHeightArr[index]}px`, alignItems: "flex-start" }}>
                                  <span ref={leftInnerRefs.current[index]} style={{ padding: "2px 8px" }}>
                                    {ReactHtmlParser(
                                      `<span>${item.q_option}</span>`
                                    )}
                                  </span>
                                </li>
                              ) : null}
                          </MathJax>
                        )})}
                      </div>
                      
                      <div className='col-md-6'>
                        <DragDropContext onDragEnd={(result) => onDragEnd(result, itemst.options)}>
                          <Droppable droppableId={"droppable"+qInd}>
                            {(provided, snapshot) => (
                              <div
                              
                                {...provided.droppableProps}
                                ref={provided.innerRef}
                                style={{...getListStyle(snapshot.isDraggingOver),padding:"0 0 0 12px"}}
                              >
                                {itemst?.options?.map((item, index) => (
                                  <Draggable key={item.oid} draggableId={item.oid?.toString()} index={index} >
                                    {(provided, snapshot) => { 
                                      rightInnerRefs.current[index] = React.createRef();
                                      return (
                                        <div className="mb-12px">
                                          <div
                                            className='match-option'
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                            {...provided.dragHandleProps}
                                            style={{...getItemStyle(
                                              snapshot.isDragging,
                                              provided.draggableProps.style
                                            ), height:`${finalHeightArr[index]}px`}}
                                          >
                                           <span ref={rightInnerRefs.current[index]} style={{display:"block",padding:"2px 8px"}}>
                                              <MathJax inline dynamic>
                                                {item?.q_option_match}
                                              </MathJax>
                                            </span>
                                          </div>
                                      </div>
                                    )}}
                                  </Draggable>
                                ))}
                                {provided.placeholder}
                              </div>
                            )}
                          </Droppable>
                        </DragDropContext>
                      </div>
                    </ul>
                  </div>
                )}
                {/* Short Answer */}
                {question.question_type == "Short Answer" &&
                  question.options.map((item, index) => (
                    <MathJax inline dynamic key={index}>
                    <OptionShortAnswer
                      isAssessmentReview={isAssessmentReview}
                      grpId={grpId}
                      qInd={qInd}
                      item={item}
                      index={index}
                      question={question}
                      refreshprops={refreshprops}
                      setanswer={setsingleanswer}
                      answer={singleanswer}
                    />
                    </MathJax>
                  ))}
                {/* Long Answer */}
                {question.question_type == "Long Answer" && (
                  <MathJax inline dynamic>
                  <OptionLongAnswer
                    isAssessmentReview={isAssessmentReview}
                    grpId={grpId}
                    qInd={qInd}
                    question={question}
                    refreshprops={refreshprops}
                    setanswer={settypeanswer}
                    answer={typeanswer}
                  />
                  </MathJax>
                )}
                {/* Fill In The Blank */}
                {question.question_type === "Fill in the blank" &&
                  <MathJax inline dynamic>
                    <FillInTheBlanks
                      isAssessmentReview={isAssessmentReview}
                      grpId={grpId}
                      qInd={qInd}
                      question={question}
                      answer={answer}
                      setanswer={setanswer}
                      refresh={refresh}
                      setrefresh={setrefresh}
                      refreshprops={refreshprops}
                    />
                  </MathJax>}
                {/* Order List */}
                {question.question_type === "Order List" &&
                  <DragDropContext onDragEnd={(result) => onDragEnd(result, itemst.options)}>
                    <Droppable droppableId={"droppable" + qInd}>
                      {(provided, snapshot) => (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          className={`order__list__wrapper ${isAssessmentReview ? 'pointer-none':''}`}
                        >
                          {itemst?.options?.map((item, index) => (
                            <Draggable key={item.oid} draggableId={item.oid?.toString()} index={index} >
                              {(provided, snapshot) => (
                                <div
                                  className='order__list__options'
                                  ref={provided.innerRef}
                                  {...provided.draggableProps}
                                  {...provided.dragHandleProps}
                                  style={getItemStyle(
                                    snapshot.isDragging,
                                    provided.draggableProps.style
                                  )}
                                >
                                  <MathJax inline dynamic>
                                    {HtmlParser(item.q_option)}
                                  </MathJax>
                                </div>
                              )}
                            </Draggable>
                          ))}
                          {provided.placeholder}
                        </div>
                      )}
                    </Droppable>
                  </DragDropContext>
                }
                {/* Choice Matrix */}
                {question.question_type === "Choice Matrix" &&
                <MathJax inline dynamic>
                  <ChoiceMatrix
                    isAssessmentReview={isAssessmentReview}
                    grpId={grpId}
                    qInd={qInd}
                    question={question}
                    refresh={refresh}
                    setrefresh={setrefresh}
                    refreshprops={refreshprops}
                    answer={answer}
                    setanswer={setanswer}
                  />
                </MathJax>}
                {/* Document Upload */}
                {question.question_type === "Document Upload" &&
                  <DocumentUpload 
                    grpId={grpId}
                    qInd={qInd}
                    question={question}
                    refresh={refresh}
                    setrefresh={setrefresh}
                    refreshprops={refreshprops}
                    answer={answer}
                    setanswer={setanswer}
                    isAssessmentReview={isAssessmentReview}
                    isPreview={isPreview}
                    assignmentData={props?.assignmentData}
                    triggerClick={props.triggerClick}
                  />
                }
              </div>
            </div>
      )}
    </div>
  );
}

export default DisplayQuestion;

// a little function to help us with reordering the result
const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  padding: 2,
  margin: `0 0 8`,
  // change background colour if dragging
  background: isDragging ? "transparent" : "transparent",
  // styles we need to apply on draggables
  ...draggableStyle
});

const getListStyle = isDraggingOver => ({
  // background: isDraggingOver ? "transparent" : "transparent",
  padding: '0px 8px ',
});

